import { render, staticRenderFns } from "./contrato.vue?vue&type=template&id=24ff0142&scoped=true"
import script from "./contrato.vue?vue&type=script&lang=js"
export * from "./contrato.vue?vue&type=script&lang=js"
import style0 from "./contrato.vue?vue&type=style&index=0&id=24ff0142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff0142",
  null
  
)

export default component.exports